// /home/labdoo/zitech-nexus/frontend/src/pages/DashboardServiceRequest.tsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { serviceAPI } from '../services/api';
import './DashboardServiceRequest.css';

// SVG Icons
const Icons = {
  Upload: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3V15M12 15L9 12M12 15L15 12" />
      <path d="M5 17V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V17" />
    </svg>
  ),
  Close: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Check: () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12L11 15L16 9" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="dsr-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Image: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ),
  Pdf: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  Doc: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0ea5e9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4H10L14 8V20H4V4Z" />
      <line x1="8" y1="12" x2="12" y2="12" />
      <line x1="8" y1="16" x2="10" y2="16" />
    </svg>
  ),
  Excel: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="8" y1="8" x2="16" y2="8" />
      <line x1="8" y1="12" x2="12" y2="12" />
    </svg>
  ),
  Zip: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4H10L14 8V20H4V4Z" />
      <line x1="8" y1="12" x2="12" y2="12" />
      <line x1="8" y1="16" x2="10" y2="16" />
    </svg>
  ),
  File: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4H10L14 8V20H4V4Z" />
    </svg>
  ),
  Cancel: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Submit: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  CheckCircle: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  Warning: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 9v4M12 17h.01" />
      <circle cx="12" cy="12" r="10" />
    </svg>
  ),
  Error: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
};

interface ServiceRequestForm {
  serviceName: string;
  customerName: string;
  email: string;
  phone: string;
  companyName: string;
  message: string;
  selectedTechnologies: string[];
}

interface FileAttachment {
  id: string;
  name: string;
  size: number;
  type: string;
  file: File;
}

interface FieldError {
  message: string;
  touched: boolean;
}

interface FormErrors {
  serviceName?: FieldError;
  customerName?: FieldError;
  email?: FieldError;
  phone?: FieldError;
  message?: FieldError;
  technologies?: FieldError;
  submit?: string;
}

interface Service {
  id: number;
  name: string;
  description: string;
  is_active: boolean;
}

const DashboardServiceRequest: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [submitted, setSubmitted] = useState(false);
  const [attachments, setAttachments] = useState<FileAttachment[]>([]);
  const [errors, setErrors] = useState<FormErrors>({});
  const [touched, setTouched] = useState<Record<string, boolean>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [services, setServices] = useState<Service[]>([]);
  const [loadingServices, setLoadingServices] = useState(true);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [formData, setFormData] = useState<ServiceRequestForm>({
    serviceName: '',
    customerName: '',
    email: '',
    phone: '',
    companyName: '',
    message: '',
    selectedTechnologies: [],
  });

  const technologiesList = [
    'React', 'Angular', 'Vue.js', 'Django', 'Node.js', 'Python', 
    'Java', 'Spring Boot', 'Laravel', 'PostgreSQL', 'MongoDB', 'MySQL',
    'AWS', 'Docker', 'Kubernetes', 'React Native', 'Flutter', 'Swift',
    'Kotlin', 'Git', 'TypeScript', 'JavaScript', 'HTML/CSS', 'PHP'
  ];

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await serviceAPI.getAllServices();
      setServices(response.data);
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      setLoadingServices(false);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      setFormData(prev => ({
        ...prev,
        customerName: user.full_name || '',
        email: user.email || '',
        phone: user.phone_number || '',
        companyName: user.company_name || '',
      }));
    }

    const params = new URLSearchParams(location.search);
    const service = params.get('service');
    if (service) {
      setFormData(prev => ({ ...prev, serviceName: service }));
    }
  }, [location]);

  // Validation functions
  const validateServiceName = (value: string): string => {
    if (!value) return 'Please select a service';
    return '';
  };

  const validateCustomerName = (value: string): string => {
    if (!value.trim()) return 'Full name is required';
    if (value.trim().length < 2) return 'Full name must be at least 2 characters';
    if (value.trim().length > 100) return 'Full name must be less than 100 characters';
    if (!/^[a-zA-Z\s\-']+$/.test(value.trim())) return 'Please enter a valid name (letters, spaces, hyphens, apostrophes only)';
    return '';
  };

  const validateEmail = (value: string): string => {
    if (!value.trim()) return 'Email address is required';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value.trim())) return 'Please enter a valid email address (e.g., name@domain.com)';
    const domain = value.trim().split('@')[1];
    if (!domain || domain.split('.').length < 2) return 'Please enter a valid email address';
    return '';
  };

  const validatePhone = (value: string): string => {
    if (!value.trim()) return 'Phone number is required';
    const phoneRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,5}[-\s.]?[0-9]{1,5}$/;
    if (!phoneRegex.test(value.trim())) return 'Please enter a valid phone number';
    const digits = value.replace(/[\s\-()]/g, '');
    if (digits.length < 10) return 'Phone number must have at least 10 digits';
    if (digits.length > 15) return 'Phone number must have at most 15 digits';
    return '';
  };

  const validateMessage = (value: string): string => {
    if (!value.trim()) return 'Project details are required';
    const charCount = value.trim().length;
    if (charCount < 100) return `Project details must be at least 100 characters (currently ${charCount})`;
    if (charCount > 5000) return 'Project details must be less than 5000 characters';
    return '';
  };

  const validateTechnologies = (value: string[]): string => {
    if (formData.serviceName === 'training_programs' && value.length === 0) {
      return 'Please select at least one technology for training';
    }
    return '';
  };

  const validateField = (field: keyof ServiceRequestForm, value: any): string => {
    switch (field) {
      case 'serviceName': return validateServiceName(value);
      case 'customerName': return validateCustomerName(value);
      case 'email': return validateEmail(value);
      case 'phone': return validatePhone(value);
      case 'message': return validateMessage(value);
      case 'selectedTechnologies': return validateTechnologies(value);
      default: return '';
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    
    let value = formData[name as keyof ServiceRequestForm];
    if (name === 'selectedTechnologies') {
      value = formData.selectedTechnologies;
    }
    const error = validateField(name as keyof ServiceRequestForm, value);
    if (error) {
      setErrors(prev => ({
        ...prev,
        [name]: { message: error, touched: true }
      }));
    } else {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name as keyof FormErrors];
        return newErrors;
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    
    // Clear field error when user starts typing
    if (errors[name as keyof FormErrors]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name as keyof FormErrors];
        return newErrors;
      });
    }
    
    // If touched, validate on change
    if (touched[name]) {
      const error = validateField(name as keyof ServiceRequestForm, value);
      if (error) {
        setErrors(prev => ({
          ...prev,
          [name]: { message: error, touched: true }
        }));
      } else {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[name as keyof FormErrors];
          return newErrors;
        });
      }
    }
  };

  const handleServiceSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setFormData({
      ...formData,
      serviceName: selectedValue,
    });
    setTouched(prev => ({ ...prev, serviceName: true }));
    
    const error = validateServiceName(selectedValue);
    if (error) {
      setErrors(prev => ({
        ...prev,
        serviceName: { message: error, touched: true }
      }));
    } else {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.serviceName;
        return newErrors;
      });
    }
  };

  const handleTechnologyToggle = (tech: string) => {
    setFormData(prev => {
      const isSelected = prev.selectedTechnologies.includes(tech);
      const updatedTechnologies = isSelected
        ? prev.selectedTechnologies.filter(t => t !== tech)
        : [...prev.selectedTechnologies, tech];
      
      setTouched(prevTouched => ({ ...prevTouched, selectedTechnologies: true }));
      
      const error = validateTechnologies(updatedTechnologies);
      if (error) {
        setErrors(prevErrors => ({
          ...prevErrors,
          technologies: { message: error, touched: true }
        }));
      } else {
        setErrors(prevErrors => {
          const newErrors = { ...prevErrors };
          delete newErrors.technologies;
          return newErrors;
        });
      }
      
      return { ...prev, selectedTechnologies: updatedTechnologies };
    });
  };

  const countCharacters = (text: string): number => {
    return text.trim().length;
  };

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const maxSize = 10 * 1024 * 1024;
      const validFiles: FileAttachment[] = [];
      
      Array.from(files).forEach(file => {
        if (file.size > maxSize) {
          setErrors(prev => ({ ...prev, submit: `File ${file.name} exceeds 10MB limit` }));
        } else {
          validFiles.push({
            id: `${Date.now()}-${Math.random()}`,
            name: file.name,
            size: file.size,
            type: file.type,
            file: file,
          });
        }
      });
      
      setAttachments(prev => [...prev, ...validFiles]);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const removeAttachment = (id: string) => {
    setAttachments(prev => prev.filter(att => att.id !== id));
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const getFileIcon = (fileName: string) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(extension || '')) {
      return <Icons.Image />;
    }
    if (['pdf'].includes(extension || '')) {
      return <Icons.Pdf />;
    }
    if (['doc', 'docx'].includes(extension || '')) {
      return <Icons.Doc />;
    }
    if (['xls', 'xlsx'].includes(extension || '')) {
      return <Icons.Excel />;
    }
    if (['zip', 'rar', '7z'].includes(extension || '')) {
      return <Icons.Zip />;
    }
    return <Icons.File />;
  };

  const triggerFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const validateForm = (): boolean => {
    const newErrors: FormErrors = {};
    let isValid = true;
    
    // Validate all fields
    const serviceNameError = validateServiceName(formData.serviceName);
    const customerNameError = validateCustomerName(formData.customerName);
    const emailError = validateEmail(formData.email);
    const phoneError = validatePhone(formData.phone);
    const messageError = validateMessage(formData.message);
    const technologiesError = validateTechnologies(formData.selectedTechnologies);
    
    if (serviceNameError) {
      newErrors.serviceName = { message: serviceNameError, touched: true };
      isValid = false;
    }
    if (customerNameError) {
      newErrors.customerName = { message: customerNameError, touched: true };
      isValid = false;
    }
    if (emailError) {
      newErrors.email = { message: emailError, touched: true };
      isValid = false;
    }
    if (phoneError) {
      newErrors.phone = { message: phoneError, touched: true };
      isValid = false;
    }
    if (messageError) {
      newErrors.message = { message: messageError, touched: true };
      isValid = false;
    }
    if (technologiesError) {
      newErrors.technologies = { message: technologiesError, touched: true };
      isValid = false;
    }
    
    setErrors(newErrors);
    setTouched({
      serviceName: true,
      customerName: true,
      email: true,
      phone: true,
      message: true,
      selectedTechnologies: true,
    });
    
    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) {
      // Scroll to first error field
      const firstErrorField = document.querySelector('.dsr-form-error, .dsr-form-textarea.dsr-form-error');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        (firstErrorField as HTMLElement).focus();
      }
      return;
    }
    
    setIsSubmitting(true);
    setErrors({});
    
    const formDataToSend = new FormData();
    formDataToSend.append('service_name', formData.serviceName);
    formDataToSend.append('customer_name', formData.customerName.trim());
    formDataToSend.append('email', formData.email.trim());
    formDataToSend.append('phone', formData.phone.trim());
    formDataToSend.append('company_name', formData.companyName.trim());
    formDataToSend.append('message', formData.message.trim());
    formDataToSend.append('selected_technologies', JSON.stringify(formData.selectedTechnologies));
    
    attachments.forEach(attachment => {
      formDataToSend.append('attachments', attachment.file);
    });
    
    try {
      await serviceAPI.createServiceRequest(formDataToSend);
      setSubmitted(true);
      
      setTimeout(() => {
        navigate('/dashboard/service-requests');
      }, 3000);
    } catch (error: any) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          error.response?.data?.detail ||
                          'Failed to submit service request. Please try again.';
      setErrors({ submit: errorMessage });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const getFieldError = (field: keyof FormErrors): string | null => {
    const error = errors[field];
    if (error && typeof error === 'object' && 'message' in error) {
      return error.message;
    }
    return null;
  };

  const isFieldTouched = (field: string): boolean => {
    return touched[field] || false;
  };

  const isFieldValid = (field: keyof ServiceRequestForm): boolean => {
    return isFieldTouched(field) && !getFieldError(field as keyof FormErrors);
  };

  const characterCount = countCharacters(formData.message);
  const isTrainingService = formData.serviceName === 'training_programs';
  const isCharacterCountValid = characterCount >= 100;
  const isCharacterCountWarning = characterCount > 0 && characterCount < 100;

  if (loadingServices) {
    return (
      <div className="dsr-loading-container">
        <div className="dsr-spinner">
          <Icons.Spinner />
        </div>
        <p className="dsr-loading-text">Loading services...</p>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="dsr-success-container">
        <div className="dsr-success-icon">
          <Icons.Check />
        </div>
        <h2 className="dsr-success-title">Service Request Submitted Successfully!</h2>
        <p className="dsr-success-text">Thank you for your request. Our team will review it and get back to you shortly.</p>
        <button className="dsr-success-btn" onClick={() => navigate('/dashboard/service-requests')}>
          View My Requests
        </button>
      </div>
    );
  }

  return (
    <div className="dsr-container">
      {/* Header */}
      <div className="dsr-header">
        <h1 className="dsr-title">Request a Service</h1>
        <p className="dsr-subtitle">
          Fill out the form below and we'll get back to you within 24 hours
        </p>
      </div>

      {/* Form */}
      <form className="dsr-form" onSubmit={handleSubmit} noValidate>
        {errors.submit && (
          <div className="dsr-error-alert">
            <span className="dsr-error-icon">⚠️</span>
            <span className="dsr-error-text">{errors.submit}</span>
          </div>
        )}

        <div className="dsr-form-grid">
          {/* Left Column */}
          <div className="dsr-form-left">
            <div className="dsr-card">
              <h3 className="dsr-card-title">Service Information</h3>
              
              <div className="dsr-form-group">
                <label className="dsr-form-label">
                  Service Required *
                  {isFieldValid('serviceName') && (
                    <span className="dsr-validation-icon dsr-valid">
                      <Icons.CheckCircle />
                    </span>
                  )}
                </label>
                <select
                  name="serviceName"
                  className={`dsr-form-select ${isFieldTouched('serviceName') && getFieldError('serviceName') ? 'dsr-form-error' : ''} ${isFieldValid('serviceName') ? 'dsr-form-valid' : ''}`}
                  value={formData.serviceName}
                  onChange={handleServiceSelect}
                  onBlur={handleBlur}
                  required
                >
                  <option value="">Select a service...</option>
                  {services.map((service) => (
                    <option key={service.id} value={service.name}>
                      {service.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    </option>
                  ))}
                </select>
                {getFieldError('serviceName') && (
                  <div className="dsr-form-error-text">
                    <Icons.Error />
                    {getFieldError('serviceName')}
                  </div>
                )}
              </div>

              <div className="dsr-form-group">
                <label className="dsr-form-label">
                  Full Name *
                  {isFieldValid('customerName') && (
                    <span className="dsr-validation-icon dsr-valid">
                      <Icons.CheckCircle />
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  name="customerName"
                  className={`dsr-form-input ${isFieldTouched('customerName') && getFieldError('customerName') ? 'dsr-form-error' : ''} ${isFieldValid('customerName') ? 'dsr-form-valid' : ''}`}
                  placeholder="Enter your full name"
                  value={formData.customerName}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  required
                />
                {getFieldError('customerName') && (
                  <div className="dsr-form-error-text">
                    <Icons.Error />
                    {getFieldError('customerName')}
                  </div>
                )}
              </div>

              <div className="dsr-form-group">
                <label className="dsr-form-label">
                  Email Address *
                  {isFieldValid('email') && (
                    <span className="dsr-validation-icon dsr-valid">
                      <Icons.CheckCircle />
                    </span>
                  )}
                </label>
                <input
                  type="email"
                  name="email"
                  className={`dsr-form-input ${isFieldTouched('email') && getFieldError('email') ? 'dsr-form-error' : ''} ${isFieldValid('email') ? 'dsr-form-valid' : ''}`}
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  required
                />
                {getFieldError('email') && (
                  <div className="dsr-form-error-text">
                    <Icons.Error />
                    {getFieldError('email')}
                  </div>
                )}
              </div>

              <div className="dsr-form-group">
                <label className="dsr-form-label">
                  Phone Number *
                  {isFieldValid('phone') && (
                    <span className="dsr-validation-icon dsr-valid">
                      <Icons.CheckCircle />
                    </span>
                  )}
                </label>
                <input
                  type="tel"
                  name="phone"
                  className={`dsr-form-input ${isFieldTouched('phone') && getFieldError('phone') ? 'dsr-form-error' : ''} ${isFieldValid('phone') ? 'dsr-form-valid' : ''}`}
                  placeholder="Enter your phone number (e.g., +1234567890)"
                  value={formData.phone}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  required
                />
                {getFieldError('phone') && (
                  <div className="dsr-form-error-text">
                    <Icons.Error />
                    {getFieldError('phone')}
                  </div>
                )}
              </div>

              <div className="dsr-form-group">
                <label className="dsr-form-label">Company Name (Optional)</label>
                <input
                  type="text"
                  name="companyName"
                  className="dsr-form-input"
                  placeholder="Enter your company name"
                  value={formData.companyName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="dsr-form-right">
            <div className="dsr-card">
              <h3 className="dsr-card-title">Project Details</h3>
              
              <div className="dsr-form-group">
                <label className="dsr-form-label">
                  Project Details * (Minimum 100 characters)
                  {isFieldValid('message') && (
                    <span className="dsr-validation-icon dsr-valid">
                      <Icons.CheckCircle />
                    </span>
                  )}
                </label>
                <textarea
                  name="message"
                  className={`dsr-form-textarea ${isFieldTouched('message') && getFieldError('message') ? 'dsr-form-error' : ''} ${isFieldValid('message') ? 'dsr-form-valid' : ''}`}
                  rows={8}
                  placeholder="Please describe your project requirements, goals, and any specific features you need in detail..."
                  value={formData.message}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  required
                />
                <div className="dsr-char-count">
                  <span className={isCharacterCountValid ? 'dsr-char-valid' : isCharacterCountWarning ? 'dsr-char-warning' : 'dsr-char-invalid'}>
                    Characters: {characterCount} / 100
                    {isCharacterCountWarning && ' (Minimum 100 characters)'}
                  </span>
                  {isCharacterCountValid && <span className="dsr-char-check">✓ Minimum reached</span>}
                </div>
                {getFieldError('message') && (
                  <div className="dsr-form-error-text">
                    <Icons.Error />
                    {getFieldError('message')}
                  </div>
                )}
              </div>

              {isTrainingService && (
                <div className="dsr-form-group">
                  <label className="dsr-form-label">
                    Technologies for Training *
                    {isFieldValid('selectedTechnologies') && (
                      <span className="dsr-validation-icon dsr-valid">
                        <Icons.CheckCircle />
                      </span>
                    )}
                  </label>
                  <p className="dsr-tech-hint">Select the technologies you want to be trained on</p>
                  <div className="dsr-tech-grid">
                    {technologiesList.map(tech => (
                      <label key={tech} className="dsr-tech-item">
                        <input
                          type="checkbox"
                          checked={formData.selectedTechnologies.includes(tech)}
                          onChange={() => handleTechnologyToggle(tech)}
                        />
                        <span className="dsr-tech-name">{tech}</span>
                      </label>
                    ))}
                  </div>
                  {getFieldError('technologies') && (
                    <div className="dsr-form-error-text">
                      <Icons.Error />
                      {getFieldError('technologies')}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Attachments */}
            <div className="dsr-card">
              <h3 className="dsr-card-title">Attachments (Optional)</h3>
              
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileUpload}
                multiple
                className="dsr-file-hidden"
                accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.zip"
              />
              <button type="button" className="dsr-upload-btn" onClick={triggerFileUpload}>
                <Icons.Upload />
                Click to upload documents or images
              </button>
              <p className="dsr-file-hint">Supported formats: JPG, PNG, GIF, PDF, DOC, DOCX, XLS, XLSX, ZIP (Max 10MB each)</p>
              
              {attachments.length > 0 && (
                <div className="dsr-attachments">
                  {attachments.map((file) => (
                    <div key={file.id} className="dsr-attachment">
                      <span className="dsr-attachment-icon">{getFileIcon(file.name)}</span>
                      <div className="dsr-attachment-info">
                        <span className="dsr-attachment-name">{file.name}</span>
                        <span className="dsr-attachment-size">{formatFileSize(file.size)}</span>
                      </div>
                      <button type="button" className="dsr-remove-attachment" onClick={() => removeAttachment(file.id)}>
                        <Icons.Close />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="dsr-form-actions">
          <button type="button" className="dsr-btn-secondary" onClick={() => navigate('/dashboard')}>
            <Icons.Cancel />
            Cancel
          </button>
          <button type="submit" className="dsr-btn-primary" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="dsr-spinner-small"></span>
                Submitting...
              </>
            ) : (
              <>
                <Icons.Submit />
                Submit Request
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DashboardServiceRequest;